import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from "./Button";
import Label from "./Label";

/**
 * Class representing a radio input.
 */
class Radio extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // The radio label
        label: PropTypes.string,

        // specific button styling class
        buttonClass: PropTypes.string,
        buttonStep2: PropTypes.string,

        // The radio data for each choices
        data: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            disabled: PropTypes.bool
        })),

        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        
        onChange: PropTypes.func
    };

    static defaultProps = {
        data: []
    };

    state = {
        value: this.props.value,
        buttonClass:"",
        buttonStep2:""
    };

    /**
     * Triggered when a choice is made.
     *
     * @param value
     *
     * @returns {Function}
     */
    onChange = value => () => {
        this.setState({value});

        this.props.onChange && this.props.onChange(value);
    };

    render() {
        const {value} = this.state;
        const {className,buttonStep2,buttonClass, label, data,order} = this.props;

        const classes = classNames(
            "cccu-radio",
            "row",
            "justify-content-around",
            {
                [className]: className !== undefined,
            }
        );

        return (
            <div className={classes}>
                {label &&
                    <div className="radio-label">
                        <Label>{label}</Label>
                    </div>
                }
                {data.map((v, k) => {
                  
                 
                    const buttonClasses = classNames({selected: v.value === value},buttonClass,buttonStep2);
                    return (
                       
                      <div key={k} className={"radio-container"+(v.value === 1  && Number(order)!==3 ? ' raw-1' : '')}>
                        <Button className={buttonClasses} onClick={this.onChange(v.value)} disabled={v.disabled===true}>
                            {v.label}
                        </Button>
                      </div>
                    )
                })}
            </div>
        )
    }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/widgets/Radio.js